import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.ENV,
    integrations: [new Integrations.BrowserTracing()],
    /**
     * The traces sample rate determines how many of the tracked errors (transactions) are sent to Sentry.
     * A value of 0.2 means 20% of all errors will be sent.
     *
     * This should be adjusted depending on the project, as sending too many errors may impact client performance.
     *
     * @see https://docs.sentry.io/platforms/javascript/guides/react/performance/#configure-the-sample-rate
     */
    tracesSampleRate: 1.0,
    ignoreErrors: ['AbortError', 'NotAllowedError'],
});
